import { ReactComponent as CaretDown } from "app/assets/svg/caret-down.svg"

const DropdownIndicator = () => {
  return <CaretDown />
}

export default DropdownIndicator
